// User role enum - home tutor role
export enum UserRole {
  HOME_TUTOR = 'teacher'
}

// OAuth provider enum - local registration
export enum OAuthProvider {
  LOCAL = 'local'
}

// Gender options
export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER'
}

// Available cities for home tutoring
export enum City {
  BHOPAL = 'Bhopal'
}

// Common subjects
export enum Subject {
  MATHEMATICS = 'Mathematics',
  PHYSICS = 'Physics',
  CHEMISTRY = 'Chemistry',
  BIOLOGY = 'Biology',
  ENGLISH = 'English',
  HINDI = 'Hindi',
  COMPUTER_SCIENCE = 'Computer Science',
  SOCIAL_STUDIES = 'Social Studies',
  ECONOMICS = 'Economics',
  COMMERCE = 'Commerce'
}

export enum TeachingMode {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  HYBRID = 'HYBRID'
}